<template>
  <div
    id="modalReverterAssociacaoEventoOrcamento"
    class="modal fade"
    tabindex="-1"
  >
    <div class="modal-dialog modal-full">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Reverter associação do evento ao orçamento
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body pb-0">
            <div class="card border border-width-2 border-teal mb-3">
              <div class="card-header d-flex align-items-center p-2">
                <p class="mb-0 fw-semibold">{{ evento.nome }}</p>
              </div>
              <!-- Entidade a ser revertida -->
              <div
                v-if="entidadeReverterAssociacaoOrcamento(evento)"
                class="card-body bg-teal-50 border-bottom"
              >
                <div class="row g-2">
                  <div class="col-md-6">
                    <p class="text-muted mb-1">Centro de Custo (Agrupador)</p>
                    <p class="fw-semibold mb-0">
                      {{
                        entidadeReverterAssociacaoOrcamento(evento).codCCustoPai
                      }}
                      -
                      {{
                        entidadeReverterAssociacaoOrcamento(evento)
                          .nomeCCustoPai
                      }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p class="text-muted mb-1">Centro de Custo (Detalhado)</p>
                    <p class="fw-semibold mb-0">
                      {{
                        entidadeReverterAssociacaoOrcamento(evento)
                          .codCCustoFilho
                      }}
                      -
                      {{
                        entidadeReverterAssociacaoOrcamento(evento)
                          .nomeCCustoFilho
                      }}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p class="text-muted mb-1">Natureza Orçamentária</p>
                    <p class="fw-semibold mb-0">
                      {{
                        entidadeReverterAssociacaoOrcamento(evento)
                          .codTBOrcamento
                      }}
                      -
                      {{
                        entidadeReverterAssociacaoOrcamento(evento)
                          .nomeTBOrcamento
                      }}
                    </p>
                  </div>
                  <div class="col-md-2">
                    <p class="text-muted mb-1">Mês</p>
                    <p class="fw-semibold mb-0">
                      {{
                        nomeMes(entidadeReverterAssociacaoOrcamento(evento).mes)
                      }}
                    </p>
                  </div>
                  <div class="col-md-2">
                    <p class="text-muted mb-1">Classificação</p>
                    <p class="fw-semibold mb-0">
                      {{
                        entidadeReverterAssociacaoOrcamento(evento)
                          .classificacao ?? '-'
                      }}
                    </p>
                  </div>
                  <div class="col-md-2">
                    <p class="text-muted mb-1">Custo Aprovado</p>
                    <p class="fw-semibold mb-0">
                      {{
                        moneyToCurrencyBr(
                          entidadeReverterAssociacaoOrcamento(evento)
                            .custoAprovado,
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- Detalhes do Evento -->
              <a
                href="#collapsible-detalhes-evento"
                data-bs-toggle="collapse"
                class="collapsed link-success"
                aria-expanded="false"
                title="Detalhes do Evento"
              >
                <div class="card-header d-flex align-items-center p-2">
                  <p class="mb-0">
                    <i class="ph-caret-down collapsible-indicator me-1" />
                    Detalhes do Evento
                  </p>
                </div>
              </a>
              <div id="collapsible-detalhes-evento" class="border-top collapse">
                <div class="card-body">
                  <div class="row g-2">
                    <div class="col-md-6">
                      <p class="text-muted mb-1">Demandante (Gestor)</p>
                      <p class="fw-semibold mb-0">{{ evento.demandante }}</p>
                    </div>
                    <div class="col-md-6">
                      <p class="text-muted mb-1">Entidade Demandante</p>
                      <p class="fw-semibold mb-0">
                        {{ evento.entidadeDemandante }}
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p class="text-muted mb-1">
                        Nome do evento, patrocínio ou projeto
                      </p>
                      <p class="fw-semibold mb-0">{{ evento.nome }}</p>
                    </div>
                    <div class="col-md-6">
                      <p class="text-muted mb-1">Data</p>
                      <p class="fw-semibold mb-0">
                        {{ dateTimeSqlToDateBR(evento.dataInicial) }} -
                        {{ dateTimeSqlToDateBR(evento.dataFinal) }}
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p class="text-muted mb-1">
                        Local de realização - Cidade/Estado
                      </p>
                      <p class="fw-semibold mb-0">
                        {{ evento.local }} - {{ evento.cidade }}/{{
                          evento.estado
                        }}
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p class="text-muted mb-1">Público</p>
                      <p class="fw-semibold mb-0">
                        {{ formatWithDot(evento.publico) }}
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p class="text-muted mb-1">Observações</p>
                      <p class="fw-semibold mb-0">
                        {{ evento.observacao ?? '-' }}
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p class="text-muted mb-1">
                        Custo Total Cadastrado / Custo Total Aprovado
                      </p>
                      <p class="fw-semibold mb-0">
                        {{ moneyToCurrencyBr(evento.custoTotal) }}
                        / {{ moneyToCurrencyBr(evento.custoTotalAprovado) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Outras Entidades -->
              <a
                v-if="outrasEntidades(evento).length > 0"
                :href="'#collapsible-entidades-' + eIndex"
                data-bs-toggle="collapse"
                class="collapsed link-success"
                aria-expanded="false"
                title="Outras Entidades"
              >
                <div
                  class="card-header d-flex align-items-center p-2 border-top"
                >
                  <p class="mb-0">
                    <i class="ph-caret-down collapsible-indicator me-1" />
                    Outras Entidades ({{ outrasEntidades(evento).length }})
                  </p>
                </div>
              </a>
              <div
                :id="'collapsible-entidades-' + eIndex"
                class="border-top collapse"
              >
                <div class="card-body">
                  <div
                    class="card border mb-2"
                    v-for="(entidade, index) in outrasEntidades(evento)"
                    :key="index"
                  >
                    <div class="card-header d-flex align-items-center p-2">
                      <p class="mb-0">
                        Status atual:
                        <span
                          v-html="
                            statusEventosTranslate(entidade.status, 'label')
                          "
                        />
                      </p>
                    </div>
                    <div class="card-body">
                      <div class="row g-2">
                        <div class="col-md-6">
                          <p class="text-muted mb-1">Nome</p>
                          <p class="fw-semibold mb-0">{{ entidade.nome }}</p>
                        </div>
                        <div class="col-md-3">
                          <p class="text-muted mb-1">Classificação</p>
                          <p class="fw-semibold mb-0">
                            {{ entidade.classificacao ?? '-' }}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <p class="text-muted mb-1">Custo Total</p>
                          <p class="fw-semibold mb-0">
                            {{ moneyToCurrencyBr(entidade.custo) }}
                          </p>
                        </div>
                        <template v-if="entidade.codColigada !== null">
                          <div class="col-md-6">
                            <p class="text-muted mb-1">
                              Centro de Custo (Agrupador)
                            </p>
                            <p class="fw-semibold mb-0">
                              {{ entidade.codCCustoPai || '-' }}
                              {{
                                entidade.nomeCCustoPai
                                  ? `- ${entidade.nomeCCustoPai}`
                                  : ''
                              }}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p class="text-muted mb-1">
                              Centro de Custo (Detalhado)
                            </p>
                            <p class="fw-semibold mb-0">
                              {{ entidade.codCCustoFilho || '-' }}
                              {{
                                entidade.nomeCCustoFilho
                                  ? `- ${entidade.nomeCCustoFilho}`
                                  : ''
                              }}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p class="text-muted mb-1">Natureza Orçamentária</p>
                            <p class="fw-semibold mb-0">
                              {{ entidade.codTBOrcamento || '-' }}
                              {{
                                entidade.nomeTBOrcamento
                                  ? `- ${entidade.nomeTBOrcamento}`
                                  : ''
                              }}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p class="text-muted mb-1">Mês</p>
                            <p class="fw-semibold mb-0">
                              {{ nomeMes(entidade.mes) }}
                            </p>
                          </div>
                        </template>
                        <div v-if="entidade.observacao" class="col-md-12">
                          <p class="text-muted mb-1">Observações</p>
                          <p class="fw-semibold mb-0">
                            {{ entidade.observacao }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-success"
              title="Confirmar Avaliação"
              :disabled="disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Confirmar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { dateTimeSqlToDateBR } from '@/utils/date'
import {
  moneyToCurrencyBr,
  formatWithDot,
  statusEventosTranslate,
} from '@/utils/strings'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'UnlinkEventoOrcamentoModal',

  props: {
    periodo: {
      type: Object,
      required: true,
    },
    evento: {
      type: Object,
      required: true,
    },
    orcamento: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      orcamentos: [],
      meses: [
        { valor: 1, nome: 'Janeiro' },
        { valor: 2, nome: 'Fevereiro' },
        { valor: 3, nome: 'Março' },
        { valor: 4, nome: 'Abril' },
        { valor: 5, nome: 'Maio' },
        { valor: 6, nome: 'Junho' },
        { valor: 7, nome: 'Julho' },
        { valor: 8, nome: 'Agosto' },
        { valor: 9, nome: 'Setembro' },
        { valor: 10, nome: 'Outubro' },
        { valor: 11, nome: 'Novembro' },
        { valor: 12, nome: 'Dezembro' },
      ],
      disableButton: false,
      dateTimeSqlToDateBR,
      moneyToCurrencyBr,
      formatWithDot,
      statusEventosTranslate,
    }
  },

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    nomeMes(numero) {
      const mes = this.meses.find((m) => m.valor === Number(numero))
      return mes ? mes.nome : '-'
    },

    entidadeReverterAssociacaoOrcamento(evento) {
      return evento.entidades.find(
        (entidade) =>
          Number(entidade.codColigada) === Number(this.user.codColigada),
      )
    },

    outrasEntidades(evento) {
      const entidadeUsuario = this.entidadeReverterAssociacaoOrcamento(evento)
      return evento.entidades.filter((entidade) => entidade !== entidadeUsuario)
    },

    async save() {
      this.disableButton = true
      try {
        const entidade = this.entidadeReverterAssociacaoOrcamento(this.evento)

        const response = await this.$store.dispatch('unlinkEventosOrcamento', {
          orcamentoId: this.orcamento.id,
          entidadeId: entidade.id,
        })

        hideModal()
        this.$emit('closeModal', true)
        this.$root.$refs.notification.success(response.message)
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    showModal('modalReverterAssociacaoEventoOrcamento')
  },
}
</script>
